module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/cagliari.863ca3c375f3e5e1f67602c09fca353a.jpg";